import {
  RtbCampaignBasicFormModel,
  RtbCampaignBasicFormModelConstructorParams
} from './RtbCampaignBasicFormModel';
import { AdType, DailyBudgetPlan } from 'core/rtbCampaign/RtbCampaign';
import { AbstractDisplayFormModel } from './DisplayFormModel';
export interface PersonalizedGoldenRecommendedFormModel extends RtbCampaignBasicFormModel {
  readonly canEditBudgetPlan: boolean;
  readonly canEditPriceModel: boolean;
}

abstract class AbstractPersonalizedGoldenRecommendedFormModel extends AbstractDisplayFormModel {
  override get campaignAdType (): AdType {
    return AdType.PERSONALIZED_GOLDEN_RECOMMENDED;
  }
}

export class EditPersonalizedGoldenRecommendedFormModel extends AbstractPersonalizedGoldenRecommendedFormModel {
  constructor (...args: RtbCampaignBasicFormModelConstructorParams) {
    super('edit', ...args);
  }
  get canEditBudgetPlan (): boolean {
    return false;
  }
  get canEditPriceModel (): boolean {
    return false;
  }
}

export class CreatePersonalizedGoldenRecommendedFormModel extends AbstractPersonalizedGoldenRecommendedFormModel {

  constructor (...args: RtbCampaignBasicFormModelConstructorParams) {
    super('create', ...args);
    this.modelDailyBudgetType = DailyBudgetPlan.DAILY;
  }
  get canEditBudgetPlan (): boolean {
    return true;
  }
  get canEditPriceModel (): boolean {
    return true;
  }
}
